import React, {Component} from 'react';
import TagsInput from 'react-tagsinput';
import classNames from 'classnames';
import t from 'tcomb-form';

export default class FormTagInput extends Component {
    static displayName = 'FormTagInput';

    constructor(props) {
        super(props);
        const {value} = props;
        this.state = {
            value: value ? value.split(',') : []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value ? nextProps.value.split(',') : []
        });
    }

    handleInputChange = userInput => {
        this.setState({userInput});
    };

    handleTagChange = value => {
        value = value.map(tag => tag.trim()).filter(tag => tag.length > 0);
        this.setState({value}, () => {
            this.props.onChange(this.getValue(), this.props.ctx.path);
        });
    };

    getValue() {
        const {value} = this.state;
        return value.length ? value.join(',') : null;
    }

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.getValue();
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const {value, hasError} = this.state;
        let placeholder = this.props.options && this.props.options.placeholder;
        if (value && value.length) {
            placeholder = null;
        }
        const inputProps = {
            className: 'react-tagsinput-input',
            name: this.props.ctx.name,
            placeholder
        };
        const label = this.props.options.label || this.props.ctx.label;

        return (
            <div className={classNames('form-group', hasError && 'has-error')}>
                <label className="control-label">{label}</label>
                <TagsInput
                    value={value}
                    onChangeInput={this.handleInputChange}
                    inputProps={inputProps}
                    addKeys={[9, 13, 188]}
                    addOnBlur
                    onChange={this.handleTagChange.bind(this)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_tag_input.js